/**
 * Orders API
 * Orders API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class Device {
    
    constructor(id, title) { 
        
        Device.initialize(this, id, title);
    }

    
    static initialize(obj, id, title) { 
        obj['id'] = id;
        obj['title'] = title;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Device();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('picture')) {
                obj['picture'] = ApiClient.convertToType(data['picture'], 'String');
            }
            if (data.hasOwnProperty('officeId')) {
                obj['officeId'] = ApiClient.convertToType(data['officeId'], 'String');
            }
            if (data.hasOwnProperty('serialNum')) {
                obj['serialNum'] = ApiClient.convertToType(data['serialNum'], 'String');
            }
            if (data.hasOwnProperty('stickerNum')) {
                obj['stickerNum'] = ApiClient.convertToType(data['stickerNum'], 'String');
            }
        }
        return obj;
    }


}


Device.prototype['id'] = undefined;


Device.prototype['title'] = undefined;


Device.prototype['picture'] = undefined;


Device.prototype['officeId'] = undefined;


Device.prototype['serialNum'] = undefined;


Device.prototype['stickerNum'] = undefined;






export default Device;

